<template>
  <div class="manager_box">
    <!-- <el-select v-model="Pie_chart_value" placeholder="请选择" v-if='!jurisdiction && $cookies.get("auth_grade") == 100' @change="handleClick">
      <el-option :key="super_options.staff_id" :label="super_options.realname" :value="super_options.staff_id"></el-option>
      <el-option-group v-for="group in tableData1" :key="group.name" :label="group.name">
        <el-option v-for="item in group.value" :key="item.staff_id" :label="item.realname" :value="item.staff_id">
        </el-option>
      </el-option-group>
    </el-select>-->
    <div style="background: white; padding: 0 20px; padding-top: 12px">
      <el-cascader
        v-model="Pie_chart_value_fu"
        :options="tableData1"
        :props="{ label: 'realname', value: 'staff_id', children: 'value' }"
        @change="handleChange"
        v-if="!jurisdiction && $cookies.get('auth_grade') == 100"
      ></el-cascader>
      <el-select
        v-model="Pie_chart_value"
        placeholder="请选择"
        v-else-if="!jurisdiction && $cookies.get('auth_grade') == 80"
        @change="handleClick"
      >
        <el-option
          v-for="item in tableData1"
          :key="item.staff_id"
          :label="item.realname"
          :value="item.staff_id"
        ></el-option>
      </el-select>
      <el-select
        v-model="Pie_chart_value"
        placeholder="请选择"
        v-else-if="!jurisdiction && $cookies.get('auth_grade') == 30"
        @change="handleClick"
      >
        <el-option
          v-for="item in tableData1"
          :key="item.staff_id"
          :label="item.realname"
          :value="item.staff_id"
        ></el-option>
      </el-select>
    </div>
    <div>
      <div class="filter_box">
        <div>
          <el-cascader
            v-model="region_value"
            :options="region_options"
            @change="handleChange1"
            style="margin-right: 20px; min-width: 150px"
          ></el-cascader>
          <el-input
            placeholder="请输入内容"
            @input="input_search"
            v-model="search_name"
            class="input-with-select"
            style="margin-right: 20px; width: 300px"
          >
            <el-select
              v-model="search_value"
              slot="prepend"
              placeholder="请选择"
              style="width: 100px"
              @change="option_input"
            >
              <el-option
                label="不限"
                value
                v-if="$cookies.get('agent_company_name') == null"
                >不限</el-option
              >
              <el-option
                v-for="(item, index) in options"
                :key="index"
                :label="item.label"
                :value="item.value"
              ></el-option>
            </el-select>
            <!-- <el-button slot="append" @click="button_search" icon="el-icon-search"></el-button> -->
          </el-input>
          <el-button @click="button_search" icon="el-icon-search" type="primary"
            >搜索</el-button
          >
        </div>

        <!-- <div class="block">
          <el-date-picker
            v-model="valueDate"
            @change="changedate"
            type="daterange"
            value-format= 'timestamp'
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          ></el-date-picker>
        </div>-->
      </div>
    </div>
    <div class="tab_name">
      <div v-for="(item, index) in tab_name_list" :key="item.name">
        <el-tag
          v-if="item.value != ''"
          style="margin: 10px 20px"
          @close="close_tab(index)"
          closable
          type
          >{{ item.name }}：{{ item.value }}</el-tag
        >
      </div>
    </div>

    <div class="main" style="width: 100%" v-loading="loading">
      <div class="add_box">
        <div class="add" style="width: 100%">
          <div class="import_and_export">
            <div>
              <el-button type="primary" @click="create">新建客户</el-button>
              <el-button
                v-if="jurisdiction || current_id == Pie_chart_value"
                @click="toggle"
                plain
                >添加到我的客户</el-button
              >
              <el-button
                v-if="jurisdiction || current_id == Pie_chart_value"
                @click="release"
                >释放客户</el-button
              >
            </div>
            <el-button
              type="primary"
              @click="dialogTableVisible = true"
              v-if="$cookies.get('agent_company_name') == null"
              >导出/导入客户</el-button
            >
          </div>
          <!-- <el-dropdown v-if='!jurisdiction && current_id == Pie_chart_value' split-button type="primary" @command="handleClick_DIS" @click='click_dis'>
            客户分配
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item v-for='item in tableData1_list' :key='item.staff_id' :command="item.staff_id">{{item.realname}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>-->
          <el-dialog
            title="创建客户"
            :visible.sync="dialogFormVisible"
            class="el_table_class"
            :before-close="
              () => {
                this.city_cascader_focus();
                this.dialogFormVisible = false;
              }
            "
          >
            <el-form
              :model="form"
              class="demo-ruleForm"
              :rules="rules"
              ref="ruleForm"
            >
              <el-form-item
                label="客户姓名"
                prop="client_name"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.client_name"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写客户姓名"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="公司职位"
                prop="company_position"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.company_position"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写公司职位"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="公司名称"
                prop="company_name"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.company_name"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写公司名称"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="下次回访时间"
                prop="next_follow_time"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-date-picker
                  v-model="form.next_follow_time"
                  value-format="timestamp"
                  type="date"
                  placeholder="选择日期"
                  style="width: 90%"
                ></el-date-picker>
              </el-form-item>

              <el-form-item
                label="销售套餐"
                prop="sale_package"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  type="number"
                  v-model="form.sale_package"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写销售套餐（填写数字）"
                ></el-input>
              </el-form-item>

              <el-form-item
                label="所属行业"
                prop="industry"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-cascader
                  v-model="form.industry"
                  :props="indus_props"
                  :options="industry_data"
                  style="width: 90%"
                  placeholder="请填写所属行业"
                ></el-cascader>
              </el-form-item>

              <el-form-item
                label="客户类型"
                prop="client_sort"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-select
                  v-model="form.client_sort"
                  placeholder="请选择客户类型"
                  style="width: 90%"
                >
                  <el-option
                    v-for="(item, index) in sale_class"
                    :key="index"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="公司地址"
                prop="company_place"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-cascader
                  style="width: 90%"
                  v-model="form.company_place"
                  :options="place_data"
                  :props="place_props"
                ></el-cascader>
              </el-form-item>

              <el-form-item
                label="沟通状态"
                prop="com_status"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-cascader
                  style="width: 90%"
                  v-model="form.com_status"
                  :options="communicate_data"
                ></el-cascader>
              </el-form-item>

              <el-form-item
                v-if="department_authority"
                label="部门所属"
                :label-width="formLabelWidth"
                :required="true"
              >
                <el-select
                  v-model="product_name"
                  style="width: 90%"
                  placeholder="请选择所属"
                  class="el_input_width"
                >
                  <el-option
                    v-for="(item, index) in department"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="客户来源"
                prop="client_source"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.client_source"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写客户来源"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="联系方式"
                prop="client_phone"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.client_phone"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="请填写联系方式"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="微信号"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.client_wx"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="微信号"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="详细地址"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.company_place_detail"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="详细地址"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="沟通备注"
                :label-width="formLabelWidth"
                class="el_input_width"
              >
                <el-input
                  v-model="form.com_remarks"
                  autocomplete="off"
                  style="width: 90%"
                  placeholder="沟通备注"
                ></el-input>
              </el-form-item>
            </el-form>

            <div slot="footer" class="dialog-footer">
              <el-button type="primary" @click="cancel">取 消</el-button>
              <el-button type="primary" @click="addPro('ruleForm')"
                >确 定</el-button
              >
            </div>
          </el-dialog>
        </div>
      </div>
      <el-table
        :data="tableData"
        ref="multipleTable"
        tooltip-effect="dark"
        style="width: 100%"
        @select-all="select_all_table"
        @select="select_table"
        @sort-change="changeTableSort"
      >
        <!-- :row-class-name="tableRowClassName" -->

        <el-table-column type="selection" min-width="30"></el-table-column>
        <el-table-column label="客户姓名" min-width="90">
          <template slot-scope="scope">
            <el-button
              type="text"
              style="min-width: 30px; min-height: 26px"
              @click="showTable(scope.row)"
            >
              <span>{{ geshihua(scope.row.client_name) }}</span>
            </el-button>
          </template>
        </el-table-column>
        <!-- <el-table-column label="性别"> <template slot-scope="scope">{{scope.row.client_gender==1?'男':'女'}}</template> </el-table-column> -->
        <el-table-column label="公司名称" prop="company_name" min-width="120">
          <template slot-scope="scope">{{
            geshihua(scope.row.company_name)
          }}</template>
        </el-table-column>
        <el-table-column
          label="客户类型"
          sortable="custom"
          prop="client_sort"
          min-width="120"
        ></el-table-column>
        <el-table-column label="手机号" prop="client_phone" min-width="120">
          <template slot-scope="scope">{{
            geshihua(scope.row.client_phone)
          }}</template>
        </el-table-column>
        <el-table-column
          label="公司职位"
          prop="company_position"
          min-width="120"
        ></el-table-column>
        <el-table-column
          label="公司地址"
          prop="area"
          min-width="120"
        ></el-table-column>
        <!-- <el-table-column label="公司来源" prop="client_source"></el-table-column> -->
        <!-- <el-table-column label="沟通备注" prop="com_remarks"></el-table-column> -->
        <!-- <el-table-column label="客户所属" prop="product_name"></el-table-column> -->
        <el-table-column
          label="下次跟进时间"
          sortable="custom"
          prop="next_follow_time_ymd"
          min-width="150"
        ></el-table-column>

        <el-table-column label="下次出访时间" min-width="150">
          <template slot-scope="scope">
            {{
              scope.row.visit_client_time != "0"
                ? scope.row.visit_client_time_str_ymd
                : ""
            }}
          </template>
        </el-table-column>

        <el-table-column
          label="跟进次数"
          sortable="custom"
          prop="follow_count"
          min-width="140"
        ></el-table-column>
        <el-table-column label="沟通状态" min-width="100">
          <template slot-scope="scope">
            <el-tag
              :type="
                scope.row.com_status == 1
                  ? 'success'
                  : scope.row.com_status == 2
                  ? 'warning'
                  : scope.row.com_status == 3
                  ? 'info'
                  : ''
              "
              >{{ scope.row.com_status_name }}</el-tag
            >
          </template>
        </el-table-column>
        <el-table-column
          label="上次跟进人"
          prop="recently_staff_name"
          min-width="100"
        ></el-table-column>
        <el-table-column label="流程状态" min-width="100">
          <template slot-scope="scope">
            <el-tag>
              {{
                scope.row.follow_status_name
                  ? scope.row.follow_status_name
                  : "新客户"
              }}
            </el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="微信号" prop="client_wx"></el-table-column> -->
        <el-table-column label="客户来源" prop="client_source" min-width="100">
          <template slot-scope="scope">{{
            geshihua(scope.row.client_source)
          }}</template>
        </el-table-column>
        <el-table-column
          label="跟进时间"
          prop="follow_time"
          min-width="100"
        ></el-table-column>
      </el-table>
      <div class="pagination">
        <div>选中：{{ client_id_list.length }}</div>
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="current_change"
          @size-change="pageSizeChange"
          :current-page.sync="cilent_Page"
          :page-size="pagesize"
          :total="sale_count"
        ></el-pagination>
        <div>
          当前页：{{ tableData.length }}&nbsp;/&nbsp;总数：{{ total_index }}
        </div>
      </div>

      <el-drawer
        :show-close="closebtn"
        title="我是标题"
        size="800"
        :visible.sync="dialog"
        :with-header="false"
        :before-close="
          () => {
            this.city_cascader_focus();
            this.dialog = false;
          }
        "
      >
        <div class="detail_info">
          <div>
            <div class="nav_title">
              <div>
                <i
                  @click="close"
                  class="iconfont iconLC_icon_close_fill_circle"
                ></i>
              </div>
              <div>{{ client_name }}</div>
            </div>

            <div class="rl_flex">
              <!-- 概况 -->
              <div class="nav_left">
                <!-- 跟进状态 -->
                <div>
                  <div class="status_box">
                    <!-- 字和点的位置 -->
                    <div class="status_iter">
                      <div
                        class="status_item"
                        v-for="(item, index) in status"
                        :key="index"
                      >
                        <div
                          class="title"
                          :class="index <= status_id ? 'status_color' : ''"
                          @click="status_deal(item.follow_status_id, index)"
                        >
                          {{ item.follow_status_name }}
                        </div>
                      </div>
                    </div>
                    <div class="line_iter">
                      <div
                        class="cir_item"
                        v-for="(item, index) in status"
                        :key="index"
                      >
                        <div
                          :class="
                            index <= status_id ? 'iconduigoutianchong-' : ''
                          "
                          class="cir iconfont"
                          @click="status_deal(item.follow_status_id, index)"
                        ></div>
                        <div
                          class="line_item"
                          :class="index < status_id ? 'status_back' : ''"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>

                <!-- 客户概况 -->
                <div class="half_fl">
                  <div v-for="(item, index) in survey" :key="index">
                    <div class="title">{{ item.title }}</div>
                    <div v-if="item.cont" class="cont">{{ item.cont }}</div>
                    <div
                      v-else-if="item.input == 'date'"
                      class="cont_date_picker"
                    >
                      <el-date-picker
                        @change="nextTime"
                        v-model="item.value"
                        type="datetime"
                        placeholder="请选择下次跟进时间"
                      ></el-date-picker>
                    </div>
                    <div v-else-if="item.communicate == 'communicate'">
                      <el-select
                        @change="communicate_change"
                        v-model="item.value"
                        placeholder="请选择沟通状态"
                      >
                        <el-option
                          v-for="(item, index) in communicate_data"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                    <div
                      v-else-if="item.input == 'date_item'"
                      class="cont_date_picker"
                    >
                      <el-date-picker
                        @change="nextTime_visit"
                        v-model="item.value"
                        type="datetime"
                        placeholder="请选择出访时间"
                      ></el-date-picker>
                    </div>
                    <div v-else>
                      <el-select
                        @change="saleChange"
                        v-model="item.value"
                        placeholder="请选择客户类型"
                      >
                        <el-option
                          v-for="(item, index) in sale_class"
                          :key="index"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </div>
                </div>

                <!-- 客户总体概览 -->
                <div>
                  <div>
                    <div class="over_title">基本信息</div>
                    <div class="half_fl">
                      <div v-for="(item, index) in basic_info" :key="index">
                        <div class="title">{{ item.title }}</div>

                        <div v-if="item.select">
                          <el-select
                            @change="selectChange"
                            v-model="item.value"
                            placeholder="请选择活动区域"
                          >
                            <el-option
                              v-for="(item, index) in sex"
                              :key="index"
                              :label="item.title"
                              :value="item.value"
                            ></el-option>
                          </el-select>
                        </div>

                        <!-- 未点击 在没有值是 显示点击输入  有值显示时显示值 -->
                        <div
                          class="cont"
                          v-else-if="item.isclick && item.input"
                        >
                          <el-input
                            :placeholder="item.input"
                            v-model="item.value"
                            @blur="compile(item)"
                            type="text"
                          >
                            <i
                              @click="item.isclick = false"
                              slot="suffix"
                              class="el-input__icon el-icon-date"
                            ></i>
                          </el-input>
                        </div>
                        <div class="cont" v-else @click="item.isclick = true">
                          {{ item.value == null ? "点击输入" : item.value }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div class="over_title">详细信息</div>
                    <div class="half_fl">
                      <div
                        v-for="(item, index) in detail_info"
                        class="half_list"
                        :key="index"
                      >
                        <div class="title">{{ item.title }}</div>

                        <!--输入框 -->
                        <div v-if="item.input == '点击输入'" class="cont">
                          <div v-if="item.isclick" class="cont">
                            <el-input
                              :placeholder="item.placeholder"
                              v-model="item.value"
                              @blur="compile(item)"
                              type="text"
                            />
                          </div>
                          <div
                            style="min-height: 32px"
                            v-else
                            @click="item.isclick = true"
                          >
                            {{ item.value == null ? "点击输入" : item.value }}
                          </div>
                        </div>

                        <div v-else-if="item.input == 'multi'" class="cont">
                          <el-cascader
                            v-model="item.value"
                            :options="place_data"
                            :props="place_props"
                            @change="placeChanged"
                          ></el-cascader>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--  跟进状态-->
              <!-- <div class="nav_right">
                <div>跟进状态</div>
                <el-input type="text" placeholder="添加跟进记录" />
                <div class="rec_box">
                  <div class="item">
                    <div class="item_flex">
                      <div class="com_name">北京三门课</div>
                      <div class="item_grow">time</div>
                    </div>
                    <div>变更跟进状态</div>
                  </div>
                </div>
              </div>-->
              <div class="nav_right">
                <!-- <div class="record">跟进记录</div> -->
                <div class="btns">
                  <el-input
                    type="textarea"
                    v-model="change_list"
                    :rows="3"
                    placeholder="添加跟进记录"
                  />
                  <el-button
                    style="height: 30px"
                    @click="submit_list"
                    type="primary"
                    >提交</el-button
                  >
                </div>

                <div class="rec_box">
                  <div
                    class="item"
                    v-for="(item, index) in record"
                    :key="index"
                  >
                    <div class="item_flex">
                      <div class="com_name">
                        <i class="iconfont iconkehuguanli"></i>
                        {{ item.staff_name }}
                      </div>
                      <div class="item_grow">{{ item.create_time }}</div>
                    </div>
                    <div class="follow_detail">{{ item.follow_detail }}</div>
                    <!-- <div @click="del(item.follow_id,index)" class="follow_del">删除</div> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-drawer>
      <el-dialog
        title
        :visible.sync="dialogTableVisible"
        class="el_table_class el_dialog_import_and_export"
      >
        <el-upload
          class="upload-demo"
          drag
          :action="url_Api + '/lufish_sale/v1/excel_create_client/'"
          multiple
          name="file"
          :headers="{ token: $cookies.get('token') }"
          :data="Data_up"
          :on-success="success_upload"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">
            将文件拖到此处，或
            <em>点击上传</em>
          </div>
          <div class="el-upload__tip" slot="tip">
            只能上传xls/xlsx文件，且不超过500kb
          </div>
        </el-upload>
        <p style="margin: 20px">
          请优先
          <el-button type="text" @click="export_template_e">导出模板</el-button
          >，以便防止填写格式错误
        </p>
      </el-dialog>
    </div>
    <div class="shadow" v-show="importCustomer.length" @click="closeTable">
      <div class="Notimport">
        <div class="coat" @click.stop>
          <p>未导入客户</p>
          <el-table  :data="importCustomer" style="width: 100%">
            <el-table-column align="center" type="index" width="150" :label="importCustomerNum"></el-table-column>
            <el-table-column
              align="center"
              prop="client_name"
              label="姓名"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="client_phone"
              label="电话"
              width="150"
            >
            </el-table-column>
            <el-table-column
              align="center"
              prop="msg"
              label="未导入原因"
              width="200"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { require, url_Api } from "@/utils/http_request.js";
export default {
  data() {
    return {
      url_Api: "",
      Data_up: {},
      cascader_value: [],

      dialogTableVisible: false,
      jurisdiction: false,
      department_authority: false,
      assign_staff: false,

      paging_up_and_down: "0",
      prop_name: "",

      department: [
        {
          name: "24猎",
          value: "24猎",
        },
        {
          name: "劳务巴士",
          value: "劳务巴士",
        },
        {
          name: "渠道",
          value: "渠道",
        },
      ],

      closebtn: false,
      currentPage: 0,
      cilent_Page: 0,
      sale_count: 0,
      pagesize: 15,
      loading: true,
      options: [], //筛选列表
      tab_name_list: [
        { name: "客户名称", value: "" },
        { name: "公司名称", value: "" },
        { name: "客户来源", value: "" },
        { name: "手机号", value: "" },
        { name: "职位", value: "" },
        { name: "客户类别", value: "" },
        { name: "备注", value: "" },
        { name: "微信号", value: "" },
        { name: "地区详情", value: "" },
        { name: "客户所属", value: "" },
      ],
      search_value: "", //筛选选项
      place_data: [],
      communicate_data: [
        {
          value: "0",
          label: "未拨打",
        },
        {
          value: "1",
          label: "已接通",
        },
        {
          value: "2",
          label: "未接通",
        },
        {
          value: "3",
          label: "号码无效",
        },
      ],
      client_name: "",
      sale_class: [
        {
          label: "A",
          value: "A",
        },
        {
          label: "B",
          value: "B",
        },
        {
          label: "C",
          value: "C",
        },
        {
          label: "D",
          value: "D",
        },
      ],
      survey: [
        {
          title: "所属人员",
          cont: "北京三门课科技有限公司",
        },
        {
          title: "客户类型",
          value: "",
          type: "select",
        },
        {
          title: "下次跟进时间",
          type: "next_follow_time",
          value: null,
          isclick: false,
          input: "date",
        },
        {
          title: "沟通状态",
          communicate: "communicate",
          value: "",
          type: "select",
        },
        {
          title: "下次出访时间",
          type: "visit_client_time_str",
          value: null,
          isclick: false,
          input: "date_item",
        },
      ],
      status: [],
      status_id_dict: {},
      status_id: 0,
      sex: [
        {
          title: "男",
          value: 1,
        },

        {
          title: "女",
          value: 2,
        },
      ],
      basic_info: [
        {
          type: "client_name",
          title: "客户姓名",
          input: "请输入姓名",
          value: null,
          isclick: false,
        },
        {
          type: "client_wx",
          title: "微信号",
          value: null,
          isclick: false,
          input: "请输入微信号",
        },
        {
          type: "client_phone",
          title: "电话",
          input: "请输入电话",
          value: null,
          isclick: false,
        },

        // {
        //   type: "client_gender",
        //   title: "性别",
        //   select: "sex",
        //   value: null,
        //   isclick: false
        // }
      ],

      tableData1: [],
      super_options: {},
      Pie_chart_value: "",
      Pie_chart_value_fu: [],
      current_id: "",
      product_name: "",

      detail_info: [
        {
          type: "client_source",
          title: "客户来源",
          value: null,
          isclick: false,
          input: "点击输入",
          placeholder: "请输入客户来源",
        },
        {
          title: "公司名称",
          type: "company_name",
          value: null,
          isclick: false,
          input: "点击输入",
          placeholder: "请输入公司名称",
        },
        {
          type: "area_id",
          title: "所在城市",
          value: null,
          isclick: false,
          input: "multi",
          options: "",
        },
        {
          title: "公司职位",
          type: "company_position",
          value: null,
          isclick: false,
          input: "点击输入",
          placeholder: "请输入公司职位",
        },
        {
          title: "详细地址",
          type: "company_place_detail",
          value: null,
          isclick: false,
          input: "点击输入",
          placeholder: "请输入详细地址",
        },

        {
          title: "备注",
          type: "com_remarks",
          value: null,
          isclick: false,
          input: "点击输入",
          placeholder: "请输入备注",
        },
      ],
      dialog: false,
      formLabelWidth: "120px",
      place_props: {},
      indus_props: {
        value: "industry_id",
        label: "name",
        children: "children",
      },
      industry_data: [],
      visible: false,
      search_name: "", //搜索字符串
      valueDate: [], //筛选时间
      tableData: [],
      total_index: 0,
      form: {
        client_name: "",
        company_position: "",
        company_name: "",
        client_sort: "",
        company_place_detail: "",
        client_source: "",
        industry: "",
        sale_package: "",
        next_follow_time: "",
        company_place: "",
        com_status: "",
        // product_name: '',
        client_phone: "",
        client_wx: "",
        com_remarks: "",
      }, //表单数据
      rules: {
        client_name: [
          { required: true, message: "请输入用户名称", trigger: "blur" },
          {
            min: 1,
            max: 10,
            message: "长度在 1 到 10 个字符",
            trigger: "blur",
          },
        ],
        company_position: [
          { required: true, message: "请输入公司职位", trigger: "blur" },
        ],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" },
        ],
        client_source: [
          { required: true, message: "请输入客户来源", trigger: "blur" },
        ],
        industry: [
          { required: true, message: "请输入公司职位", trigger: "change" },
        ],
        sale_package: [
          { required: true, message: "请输入销售套餐", trigger: "change" },
        ],
        next_follow_time: [
          { required: true, message: "请选择下次回访时间", trigger: "change" },
        ],
        company_place: [
          { required: true, message: "请选择公司地址", trigger: "change" },
        ],
        com_status: [
          { required: true, message: "请选择沟通状态", trigger: "change" },
        ],
        // product_name: [
        //   { required: true, message: "请选择所属部门", trigger: "change" }
        // ],
        client_sort: [
          { required: true, message: "请选择客户类型", trigger: "change" },
        ],
        client_phone: [
          { required: true, message: "请输入手机号", trigger: "blur" },
        ],
        // client_wx: [
        //   { required: true, message: "请输入微信号", trigger: "blur" }
        // ]
      },
      dialogFormVisible: false, //创建弹框
      search_data: {},
      staff_id: "",
      client_id: "",

      change_list: "",
      record: [],
      show_client_id: "",
      client_id_list: [],

      region_value: [""],
      region_options: [
        {
          label: "不限",
          value: "",
        },
      ],

      // 导入客户列表
      importCustomer: [],
      show: false,
      importCustomerNum:0,
    };
  },


  methods: {
    // 关闭
    closeTable() {
      this.importCustomer = "";
      document.body.style.overflow = "visible";
    },
    formatDate: function (value, format) {
      if (value != 0) {
        let date = new Date(Number(value) * 1000); //这个是纳秒的，想要毫秒的可以不用除以1000000
        // console.log(date);
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 10 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 10 ? "0" + d : d;
        let h = date.getHours();
        h = h < 10 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 10 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 10 ? "0" + s : s;
        if (format) {
          return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
        } else {
          return y + "-" + MM + "-" + d;
        }
      }
    },
    city_cascader_focus() {
      if (this.$cookies.get("auth_grade") != null) {
        if (this.place_data[0].children[0].label != "不限") {
          this.place_data[0].children.unshift({
            label: "不限",
            value: this.place_data[0].value,
          });
        }
      }
    },
    //删除地址中的不限
    del_agent_place() {
      if (this.$cookies.get("auth_grade") != null) {
        console.log(this.place_data[0].children[0]);
        if (this.place_data[0].children[0].label == "不限") {
          this.place_data[0].children = this.place_data[0].children.filter(
            (item, index) => {
              return item.label != "不限";
            }
          );
        }
      }
    },
    //格式化显示的字符串
    geshihua(str) {
      var index = str.lastIndexOf(".");
      if (index === -1) {
        str = str;
      } else {
        str = str.substring(0, index);
      }
      return str;
    },
    tableRowClassName(row) {
      console.log("当前内容", row.row);
      // {
      //   value: 1,
      //   label: '已接通'
      // },{
      //   value: 2,
      //   label: '未接通'
      // },{
      //   value: 3,
      //   label: '号码无效'
      // }

      if (row.row.com_status === 1) {
        return "warning-row";
      } else if (row.row.com_status === 2) {
        return "connected-row";
      } else if (row.row.com_status === 3) {
        return "success-row";
      }
      return "";
    },
    handleClick(tab, event) {
      console.log("tab", tab);
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.client_id_list = [];
      this.$cookies.set("staff_id", tab);
      this.search();
    },
    handleClick_DIS(e) {
      // 分配
      console.log("当前要分配给的人", e);
    },
    click_dis(e) {
      console.log("当前要分配给的人", e);
    },
    // 根据时间筛选
    changedate(e) {
      console.log();
      if (e == null) {
        this.valueDate = [];
      }
      this.search();
    },

    lufish_user_list(e) {
      // let obj = this.search_data;
      // obj["page"] = this.currentPage;

      // require("post", "/lufish_user/v1/lufish_user_list/", obj).then(res => {
      //   if (!res.code) {
      //     this.tableData1 = res.data;
      //   } else {
      //     this.$message.error(res.msg);
      //   }
      // });

      require("POST", "/lufish_user/v1/lufish_staff/", {}).then((res) => {
        if (!res.code) {
          if (res.data.length > 0) {
            this.tableData1 = [];
            this.super_options = {};

            this.tableData1 = res.data;
            this.current_id = res.data[0].staff_id;
            if (!this.$cookies.get("staff_id")) {
              this.$cookies.set("staff_id", res.data[0].staff_id);
              this.Pie_chart_value = res.data[0].staff_id;
              if (this.$cookies.get("auth_grade") == 100) {
                this.Pie_chart_value_fu[0] = res.data[0].staff_id;
              }
              this.search();
            } else {
              let staff_id_split = this.$cookies.get("staff_id").split(",");
              console.log(
                "staff_id_split",
                staff_id_split,
                this.$cookies.get("staff_id")
              );
              if (this.$cookies.get("auth_grade") == 30) {
                // this.current_id = staff_id_split[0]
                this.Pie_chart_value = staff_id_split[0];
              } else {
                // this.current_id = staff_id_split[staff_id_split.length-1]
                this.Pie_chart_value =
                  staff_id_split[staff_id_split.length - 1];
                this.Pie_chart_value_fu = staff_id_split;
                console.log(
                  "Pie_chart_value",
                  this.Pie_chart_value,
                  this.Pie_chart_value_fu
                );
              }
              this.search();
            }
          }
        } else {
          this.$message.error("职员列表获取失败");
        }
        // this.loading = false
        // this.require_ech()
      });
    },

    button_search() {
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.search();
    },
    // 搜索 刷新列表
    search() {
      this.loading = true;
      let obj = this.search_data;
      obj["page"] = this.currentPage;
      obj["staff_id"] = this.Pie_chart_value;
      let search_data = {};

      // time_start, time_end
      if (this.valueDate.length > 0) {
        search_data["start_create_time"] = this.valueDate[0] / 1000;
        search_data["end_create_time"] = this.valueDate[1] / 1000;
      }
      // try {
      //   let search_key = this.options[this.search_value].type;
      //   let search_value = this.search_name;
      //   search_data[search_key] = search_value;
      // } catch (e) {}

      this.tab_name_list.forEach((element, index) => {
        if (element.value != "") {
          search_data[this.options[index].type] = element.value;
        }
      });
      if (this.$cookies.get("agent_company_name") != null) {
        if (this.region_value[0] == this.region_value[1]) {
          this.region_value = [""];
        }
      }

      if (this.region_value[this.region_value.length - 1] != "") {
        search_data["company_place"] =
          this.region_value[this.region_value.length - 1];
      }

      if (this.prop_name != "") {
        if (this.prop_name == "next_follow_status") {
          search_data.next_follow_status = this.paging_up_and_down;
        } else if (this.prop_name == "client_sort") {
          search_data.client_sort_status = this.paging_up_and_down;
        } else if (this.prop_name == "follow_count") {
          search_data.follow_info = this.paging_up_and_down;
        }
      }
      obj["search_data"] = search_data;
      require("post", "/lufish_sale/v1/lufish_basic_work_info/", obj).then(
        (res) => {
          this.loading = false;
          if (!res.code) {
            this.sale_count = res.data.basic_work_count;
            res.data.client_data_list.map((item) => {
              if (item.company_place_data.city_name) {
                // item.area = item.company_place_data.city_name + "-" + item.company_place_data.district_name;
                if (
                  item.company_place_data.city_name ==
                  item.company_place_data.province_name
                ) {
                  item.area =
                    item.company_place_data.city_name +
                    "-" +
                    item.company_place_data.district_name;
                } else {
                  item.area =
                    item.company_place_data.province_name +
                    "-" +
                    item.company_place_data.city_name +
                    "-" +
                    item.company_place_data.district_name;
                }
                item.area_id = [
                  item.company_place_data.province_code,
                  item.company_place_data.city_code,
                  item.company_place_data.district_code,
                ];
              } else {
                item.area = "";
                item.area_id = [0, 0, 0];
              }
            });
            if (this.dialog) {
              res.data.client_data_list.map((item) => {
                if (item.client_id == this.show_client_id) {
                  this.showTable(item);
                }
              });
            }
            this.total_index = res.data.basic_work_count;
            this.tableData = res.data.client_data_list;
            this.tableData = this.tableData.map((item) => {
              // 时间戳转换成时间
              // 下次跟进时间
              item.next_follow_time_ymd = this.formatDate(
                item.next_follow_time,
                false
              );
              item.next_follow_time = this.formatDate(
                item.next_follow_time,
                true
              );
              // 下次回访时间
              item.visit_client_time_str_ymd = this.formatDate(
                item.visit_client_time,
                false
              );
              item.visit_client_time_str = this.formatDate(
                item.visit_client_time,
                true
              );

              // item.next_follow_time = new Date(Number(item.next_follow_time) * 1000).toLocaleDateString().replace(/\//g, "-")
              // 把时间等于1970-01-01的去掉
              if (item.follow_time == "1970-01-01") {
                item.follow_time = "";
              }
              return item;
            });
            console.log(this.tableData);
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    input_search(e) {
      if (this.search_value !== "") {
        this.tab_name_list[this.search_value].value = e;
      }
    },
    option_input(e) {
      if (e == "") {
        this.search_name = "";
        this.tab_name_list.forEach((item) => {
          item.value = "";
        });
        // console.log('内容')
      } else {
        this.search_name = this.tab_name_list[this.search_value].value;
      }
    },
    close_tab(e) {
      // 关闭Tab 标签
      this.tab_name_list[e].value = "";
    },

    //点击详情的 × 进行修改后的刷新
    close() {
      this.dialog = false;
      // this.search();
    },

    pageSizeChange(e) {
      console.log(e);
    },

    current_change(e) {
      this.currentPage = e - 1;
      // this.cilent_Page = e;
      this.client_id_list = [];
      this.search();
    },

    //修改详情中的状态值
    status_deal(status, index) {
      if (index == 5) {
        this.$message({
          message: "请先添加到我的客户",
          type: "warning",
        });
        return false;
      }
      console.log("失败");
      this.status_id = index;
      let compile_obj = {};
      compile_obj["follow_status_id"] = status;
      this.compile_d(compile_obj);
    },

    create() {
      this.form = {
        client_name: "",
        company_position: "",
        company_name: "",
        industry: "",
        sale_package: "",
        next_follow_time: "",
        company_place: "",
        com_status: "",
        client_phone: "",
        client_wx: "",
        client_source: "",
        com_remarks: "",
      };
      this.form.next_follow_time = new Date().getTime() + 86164 * 1000; // 回访时间 --》 明天
      this.product_name = "";
      this.del_agent_place();
      this.dialogFormVisible = true;
    },

    showstatus() {
      require("post", "/lufish_sale/v1/lufish_follow_tags_list/", {}).then(
        (res) => {
          if (!res.code) {
            // 销售流程ID
            res.data.map((item, index) => {
              this.status_id_dict[item.follow_status_id] = index;
            });
            this.status = res.data;
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    showTable(e) {
      console.log(e);
      // 进行赋值
      console.log("进行赋值", e, e.com_status);
      this.change_list = "";
      this.show_client_id = e.client_id;
      this.dialog = true;
      this.staff_id = e.staff_id;
      this.client_name = e.client_name;
      this.client_id = e.client_id;
      this.status_id = this.status_id_dict[e.follow_status_id] || 0;
      this.survey[1].value = e.client_sort;
      this.survey[3].value = "" + e.com_status + "";
      console.log();
      this.del_agent_place();
      //循环数据将数据进行 验证带入值
      for (let i in e) {
        this.record = e.follow_data;
        this.detail_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              if (item.type == "area_id") {
                if (this.$cookies.get("agent_company_name") != null) {
                  item.value = [e[i][1], e[i][2]];
                } else {
                  item.value = e[i];
                }
                console.log(e[i]);
              } else {
                item.value = e[i];
              }
            } else {
              item.value = "";
            }
          }
        });

        this.basic_info.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              item.value = e[i];
            } else {
              item.value = "";
            }
          }
        });
        this.survey.map((item, index) => {
          if (i == item.type) {
            if (e[i]) {
              if (e[i] == "1970-01-01") {
                item.value = "";
              } else {
                item.value = e[i];
              }
            } else {
              item.value = "";
            }
          }
        });
      }
      console.log(this.detail_info, this.basic_info, this.survey, this.record);
    },

    //添加客户
    addPro(formName) {
      let form = this.form,
        that = this;
      for (let i in this.rules) {
        if (form[i] == "") {
          // console.log('当前参数为空', form[i])
          this.$message.error("请检查数据格式");
          return;
        }
      }
      if (this.department_authority) {
        if (this.product_name == "") {
          this.$message.error("请检查数据格式");
          return false;
        } else {
          form.product_name = this.product_name;
        }
      }
      form.industry = form.industry[1];

      form.company_place = form.company_place[form.company_place.length - 1];
      form.com_status = form.com_status[0];
      form.next_follow_time = form.next_follow_time / 1000;
      if (!this.jurisdiction) {
        form.product_name = this.product_name;
      }
      console.log(form);
      let create_client = JSON.stringify(form);
      let obj = {
        label_code: "create",
        create_client,
      };
      if (!this.jurisdiction) {
        obj.staff_id = this.Pie_chart_value;
      }
      require("post", "/lufish_sale/v1/lufish_sale_client/", obj).then(
        (res) => {
          if (res.code == 0) {
            that.dialogFormVisible = false;
            that.$message({ message: "添加客户成功", type: "success" });
            that.search();

            // 重新加载
            that.form = {
              client_name: "",
              company_position: "",
              company_name: "",
              industry: "",
              sale_package: "",
              next_follow_time: "",
              company_place: "",
              com_status: "",
              // product_name: '',
              client_phone: "",
              client_wx: "",
              client_source: "",
              com_remarks: "",
            };
            this.product_name = "";
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    //详情输入框进行修改
    compile(item) {
      item.isclick = false;
      let compile_obj = {};
      compile_obj[item.type] = item.value;
      this.compile_d(compile_obj);
    },

    //以下是非input修改的
    placeChanged(e) {
      let compile_obj = {};
      compile_obj["company_place"] = e[2];
      this.compile_d(compile_obj);
    },

    selectChange(e) {
      let compile_obj = {};
      compile_obj["client_gender"] = e;
      this.compile_d(compile_obj);
    },
    communicate_change(e) {
      let compile_obj = {};
      compile_obj["com_status"] = e;
      this.compile_d(compile_obj);
    },
    saleChange(e) {
      let compile_obj = {};
      compile_obj["client_sort"] = e;
      this.compile_d(compile_obj);
    },

    nextTime(e) {
      const d = new Date();
      const miao = Math.floor(d.getTime() / 1000);
      let time = e.getTime() / 1000;
      if (time < miao) {
        this.$message({
          message: "选择的时间不能低于当前时间",
          type: "warning",
        });
        this.survey.forEach((item) => {
          if (item.input == "date") {
            item.value = d;
          }
        });
        return;
      }
      let compile_obj = {};
      compile_obj["next_follow_time"] = time;
      this.compile_d(compile_obj);
    },
    nextTime_visit(e) {
      let time = e.getTime() / 1000;
      let compile_obj = {};
      compile_obj["visit_client_time"] = time;
      this.compile_d(compile_obj);
    },

    cancel() {
      this.dialogFormVisible = false;
    },

    //修改接口
    compile_d(obj = {}) {
      let follow_update = {
        label_code: "update",
        client_id: this.client_id,
        update_client: obj,
      };
      if (!this.jurisdiction) {
        follow_update.staff_id = this.Pie_chart_value;
      }
      require("post", "/lufish_sale/v1/lufish_sale_client/", follow_update).then(
        (res) => {
          if (!res.code) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.search();
          } else {
            this.$message.error(res.msg);
          }
        }
      );
    },

    //选择客户拉进私海
    toggle(row, selected) {
      let sele_list = [];
      this.$refs.multipleTable.selection.map((item) => {
        sele_list.push(item.client_id);
      });

      if (sele_list.length) {
        this.loading = true;
        let obj = {
          client_id_list: sele_list,
        };
        require("post", "/lufish_sale/v1/lufish_work_me/", obj).then((res) => {
          if (!res.code) {
            this.$message({
              message: res.msg,
              type: "success",
            });
            this.search();
          } else {
            this.loading = false;
            this.$message.error(res.msg);
          }
        });
      } else {
        this.$message.error("请选择客户");
      }
    },

    submit_list() {
      let obj = {
        label_code: "create",
        create_data: {
          client_id: this.client_id,
          follow_detail: this.change_list,
        },
      };

      if (!this.jurisdiction) {
        obj.staff_id = this.Pie_chart_value;
      }

      var new_change = this.change_list.replace(/\s*/g, "");

      console.log(new_change);

      if (new_change == "") {
        this.$message.error("请输入跟进内容");
      } else {
        require("post", "/lufish_sale/v1/lufish_sale_follow/", obj).then(
          (res) => {
            if (!res.code) {
              this.$message({
                message: res.msg,
                type: "success",
              });

              let record_obj = {
                staff_name: this.$cookies.get("realname"),
                follow_detail: this.change_list,
                create_time: this.getCurrentTime(),
              };

              this.record.unshift(record_obj);
              this.change_list = "";
            } else {
              this.$message.error(res.msg);
            }
          }
        );
      }
    },
    //获取
    getCurrentTime() {
      let date = new Date();
      let Y = date.getFullYear();
      let M =
        date.getMonth() + 1 < 10
          ? "0" + (date.getMonth() + 1)
          : date.getMonth() + 1;
      let D = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
      let hours = date.getHours();
      let minutes =
        date.getMinutes() < 10 ? "0" + date.getMinutes() : date.getMinutes();

      date = Y + "-" + M + "-" + D + " " + hours + ":" + minutes;
      console.log(date); //2019-10-12 15:19:33
      return date;
    },

    release() {
      // 释放缓存
      if (this.client_id_list.length == 0) {
        this.$message({
          message: "请选择释放的客户",
          type: "warning",
        });
        return false;
      }
      this.loading = true;
      require("POST", "/lufish_sale/v1/lufish_work_highseas/", {
        client_id_list: this.client_id_list,
      }).then((res) => {
        if (!res.code) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.search();
        } else {
          this.loading = false;
          this.$message.error(res.msg);
        }
      });
    },
    select_all_table(e) {
      this.client_id_list = [];
      if (e.length > 0) {
        e.map((item) => {
          this.client_id_list.push(item.client_id);
        });
      } else {
        this.$message.error(res.msg);
      }
    },
    select_table(e) {
      this.client_id_list = [];
      if (e.length > 0) {
        e.map((item) => {
          this.client_id_list.push(item.client_id);
        });
      }
    },
    changeTableSort(e) {
      console.log("自定义", e);
      this.client_id_list = [];
      this.currentPage = 0;
      this.cilent_Page = 1;
      if (e.prop == "next_follow_time") {
        this.prop_name = "next_follow_status";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      } else if (e.prop == "client_sort") {
        this.prop_name = "client_sort";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      } else if (e.prop == "follow_count") {
        this.prop_name = "follow_count";
        if (e.order == "ascending") {
          // 上升
          this.paging_up_and_down = 0;
          this.search();
        } else if (e.order == "descending") {
          // 下降
          this.paging_up_and_down = 1;
          this.search();
        } else {
          this.prop_name = "";
          this.paging_up_and_down = "";
          this.search();
        }
      }
    },

    handleChange(e) {
      console.log("当前", e, e[e.length - 1]);
      this.currentPage = 0;
      this.cilent_Page = 1;
      this.client_id_list = [];
      this.Pie_chart_value = e[e.length - 1];
      this.$cookies.set("staff_id", e);
      this.search();
    },
    handleChange1(value) {
      console.log(value);
    },

    import_and_export() {},
    export_template_e() {
      require("post", "/lufish_sale/v1/download_excel/", {}).then((res) => {
        if (!res.code) {
          this.$message({ message: "模板导出成功", type: "success" });
          try {
            var elemIF = document.createElement("iframe");
            elemIF.src = res.data;
            elemIF.style.display = "none";
            document.body.appendChild(elemIF);
          } catch (e) {
            alert("下载异常！");
          }
        }
      });
    },
    success_upload(e) {
      console.log("成功", e);
      if (!e.code) {
        this.$message.success(e.msg);
        this.importCustomer = e.data.mistake_client_list;
        this.importCustomerNum = "总数(" + this.importCustomer.length + ")";
        document.body.style.overflow = "hidden";
      } else {
        this.$message.warning(e.msg);
      }
      this.dialogTableVisible = false;
      this.search();
      this.loading = false;
    },
  },

  created() {
    this.url_Api = url_Api;
    if (this.$cookies.get("auth_grade") == 20) {
      this.jurisdiction = true;
      this.search();
    } else {
      this.Data_up = {
        staff_id: this.$cookies.get("staff_id"),
      };
      this.lufish_user_list();
    }
    if (this.$cookies.get("auth_grade") == 100 || this.$cookies.get("auth_grade") == 30 || this.$cookies.get("auth_grade") == 20) {
      this.department_authority = true;
    }

    this.showstatus();

    let options = [
      "按客户名称",
      "按公司名称",
      "按客户来源",
      "按手机号",
      "按职位",
      "按客户类别",
      "按备注",
      "按微信号",
      "按地区详情",
    ];
    let search_data = [
      "client_name",
      "company_name",
      "client_source",
      "client_phone",
      "company_position",
      "client_sort",
      "com_remarks",
      "client_wx",
      "company_place_detail",
    ];
    let options_add = [];
    options.map((item, index) => {
      options_add.push({
        value: String(index),
        label: item,
        type: search_data[index],
      });
    });
    this.options = options_add;
    console.log("aaa");
    if (this.$cookies.get("agent_company_name") == null) {
      this.place_props = {
        value: "value",
        label: "label",
        children: "children",
      };
    } else {
      this.place_props = {
        value: "value",
        label: "label",
        children: "children",
      };
    }
  },

  mounted() {
    if (this.$cookies.get("agent_company_name") != null) {
      require("post", "/lufish_sale/v1/agent_city_json/", {}).then((res) => {
        console.log(res);
        this.region_options = res.data;
        this.place_data = res.data;
      });
    } else {
      require("post", "/commonality/v1/show_place_json/", {}).then((res) => {
        this.region_options = this.region_options.concat(res.data);
        this.place_data = res.data;
      });
    }

    axios.get("/static/json/industry.json").then((res) => {
      this.industry_data = res;
    });
  },
  beforeUpdate(e) {
    console.log(e);
  },
};
</script>

<style scoped>
.manager_box {
  margin-top: 68px;
  margin-left: 181px;
  background: #ffff;
  width: calc(100% - 181px);
  border-radius: 4px;

  background: #f8f9fa;
}
.main {
  padding-bottom: 70px;
  margin: 16px 0;
  background: #ffff;
  width: 80vw;
  border-radius: 4px;
  box-shadow: 0 0 6px rgba(32, 32, 32, 0.08);
  min-height: 80vh;
  position: relative;
}

.add_box {
  height: 68px;
  padding: 16px;
  box-sizing: border-box;
  display: flex;
}

.add .el-input {
  width: 50%;
}
.import_and_export {
  /* border:1px red solid; */
  width: 100%;
  display: flex;
  justify-content: space-between;
}

.filter_box {
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #e4e9ed;
  background: #fff;
  padding: 12px 20px;
  box-sizing: border-box;
  align-items: center;
}

.block {
  flex-grow: 1;
  margin-left: 20px;
}

.detail_info,
.detail_info > div,
.nav_left,
.nav_right,
.rl_flex {
  height: 100%;
}

.nav_title {
  padding: 16px 24px;
  border-bottom: 1px solid #e4e9ed;
  display: flex;
}

.nav_title > div {
  margin-left: 12px;
}

.rl_flex {
  display: flex;
}

.nav_left {
  width: 684px;
  border-right: 1px solid #e4e9ed;
}
.nav_left > div {
  padding: 24px;
  box-sizing: border-box;
  border-bottom: 1px solid #e4e9ed;
}

.over_title {
  margin-bottom: 16px;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  color: #333;
}

.half_fl {
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 20px;
}

.half_list:nth-child(1) .cont div {
  line-height: 22px;
  display: flex;
  align-items: center;
}

.pagination {
  position: absolute;
  left: 0;
  width: 100%;
  bottom: 10px;
  display: flex;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
}
.pagination div {
  color: #aaa;
  font-size: 15px;
}

.iconLC_icon_close_fill_circle {
  font-size: 24px;
  color: #3d76f7;
  position: absolute;
  top: 6px;
  left: 2px;
  cursor: pointer;
}

.status_box {
  height: 60px;
  width: 100%;
  display: flex;
  flex-direction: column;
  font-size: 15px;
  border-radius: 16px;
  position: relative;
}

.status_iter {
  display: flex;
  justify-content: space-between;
}

.status_item {
  display: flex;
  justify-content: center;
}

.status_color {
  color: #3d76f7;
}

.cir.status_back,
.line_item.status_back {
  background: #3d76f7;
}
.cir_item {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
}
.cir_item img {
  height: 24px;
  width: 24px;
}

.cir:hover,
.status_item .title:hover {
  cursor: pointer;
}
.line_iter {
  margin-top: 10px;
  background: #f5f6fa;
  line-height: 32px;
  height: 32px;
  overflow: hidden;
  width: 100%;
  border-radius: 16px;
  display: flex;
  justify-content: space-between;
}

.line_item {
  position: absolute;
  height: 10px;
  width: 140px;
  background: #e5e7ee;
  left: 23px;
  top: 10px;
}

.cir {
  height: 24px;
  width: 24px;
  border-radius: 50%;
  background: #e5e7ee;
  color: #3d76f7;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
}

.half_fl .title {
  width: 92px;
}

.half_fl .cont {
  color: #333;
  width: 200px;
  height: 32px;
  line-height: 32px;
}

.half_fl > div {
  align-items: center;
  display: flex;
  width: 50%;
  margin-bottom: 16px;
  font-size: 14px;
  color: #999;
}

.nav_left > div:last-child {
  border-bottom: none;
}

.nav_right {
  /* width: calc(100% - 684px); */
  width: 440px;
  padding: 16px;
  box-sizing: border-box;
  font-size: 14px;
}

.rec_box {
  max-height: calc(100vh - 250px);
  margin-top: 60px;
  overflow-y: auto;
}

.rec_box::-webkit-scrollbar {
  width: 4px;
}
.rec_box::-webkit-scrollbar-thumb {
  background-color: #d9d9d9;
}

.rec_box .item {
  margin-top: 24px;
  font-size: 14px;
  line-height: 22px;
}

.rec_box .item_flex {
  display: flex;
  justify-content: space-between;
}

.com_name {
  color: #999;
  width: 35%;
}

.item_grow {
  flex-grow: 1;
}
.btns .el-button {
  float: right;
  margin-top: 5px;
}

.tab_name {
  display: flex;
  flex-wrap: wrap;
  min-height: 50px;
  background: white;
}

.el_dialog_import_and_export {
  text-align: center;
}
.Notimport {
  width: auto;
}
.coat {
  height: 734px;
  overflow-x: auto;
  background-color: #fff;
}
.surface {
  width: 400px;
  height: 400px;
  text-align: center;
  border-top: 0.5px solid #999;
  border-left: 1px solid #999;
  border-spacing: 0;
  background: white;
}
.coat p {
  text-align: center;
  font-size: 20px;
  color: #909399;
  margin: 0;
  line-height: 61px;
  border-bottom: 1px solid #ebeef5;
}
.shadow {
  z-index: 1119;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
}
.Notimport /deep/ .el-table__header{
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/sales_management/basics_job.vue